import type { EmailStarterTemplate } from '../types'

/**
 * Minimal blank canvas — just a greeting to avoid the "scary empty page".
 */
export const blankStarter: EmailStarterTemplate = {
    id: 'blank',
    label: 'Blank email',
    description: 'Start from scratch with just a friendly hello.',
    icon: 'FileText',
    accent: '#6b7280',
    defaultSubject: '',
    defaultPreheader: '',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Hi ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'there',
                            required: false,
                        },
                    },
                    { type: 'text', text: ',' },
                ],
            },
            { type: 'paragraph' },
        ],
    },
}
